// useCompany — a single company by id (GET /v1/companies/:id).
import { useQuery } from "@tanstack/react-query";

import { getCompany } from "@/api/companies";
import { useAuth } from "@/store/auth";

export function useCompany(id: string | undefined) {
  const status = useAuth((s) => s.status);
  return useQuery({
    queryKey: ["company", id],
    queryFn: () => getCompany(id!),
    enabled: status === "authenticated" && id != null && id !== "",
    staleTime: 60_000,
  });
}
